import type { AgentContext } from './agentContext';
import { buildSystemPrompt } from './systemPrompt';
import { createTextTask, pollTextResult } from '../aiControllerService';

export interface LLMMessage {
  role: 'system' | 'user' | 'assistant' | 'tool';
  content: string | null;
}

function flattenChatPrompt(systemPrompt: string, history: LLMMessage[], userText: string): string {
  const lines = [`[SYSTEM]\n${systemPrompt.trim()}`];

  for (const message of history) {
    const content = (message.content || '').trim();
    if (!content || (message.role !== 'user' && message.role !== 'assistant')) {
      continue;
    }

    lines.push(`[${message.role.toUpperCase()}]\n${content}`);
  }

  lines.push(`[USER]\n${userText.trim()}`);
  return lines.join('\n\n');
}

function estimatePromptTokens(prompt: string): number {
  const trimmed = prompt.trim();
  if (!trimmed) {
    return 0;
  }

  return Math.ceil(Array.from(trimmed).length / 3);
}

export async function callAgent(
  context: AgentContext,
  history: LLMMessage[],
  userText: string,
): Promise<string> {
  const message = userText.trim();
  if (!message) {
    throw new Error('Thiếu nội dung để gọi AI.');
  }

  const prompt = flattenChatPrompt(buildSystemPrompt(context), history, message);

  const assignment = await createTextTask({
    prompt,
    taskType: 'text.generate',
    service: 'text2text',
    provider: 'gemini',
    estimatedTokens: estimatePromptTokens(prompt),
    meta: {
      source: 'marketing-chatbot',
      current_page: context.currentPage,
      workflow_name: context.workflowName,
    },
  });
  const content = await pollTextResult(assignment.worker_url, assignment.task_id, 1500, 120000);

  if (!content) {
    throw new Error('Hết thời gian chờ kết quả từ worker tunnel.');
  }

  return content;
}
